import { Tune } from '@material-ui/icons';
import { DailyReport } from '../models/DailyReport/DailyReportModel';

export class DailyReportUtil {
  /****************************************
   * 既読の確認(日報とコメントの既読確認)
   * @param dailyreport
   * @returns
   */
  static isAllReadCheck(dailyReport: DailyReport) {
    const comments = dailyReport.comments;

    let isRead = true;

    if (!dailyReport.is_read) {
      isRead = false;
    }

    //1レコードでも既読になっている場合
    comments.map(comment => {
      if (!comment.is_read) {
        isRead = false;
      }
    });
    return isRead;
  }
}
